import React from "react";
// import _get from "lodash/get";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';
import { formatDate, formatDateTime } from "../../actions/momentActions";
import ShippingTable from "./ShippingTable";
// import Button from '@mui/material/Button';
import SearchBar from "./SearchBar";
import {
  getAdminShippingCount,
  getAdminShipping,
} from "../../actions/adminSupportActions";
import AddShippingForm from "./AddShippingForm";

const styles = (theme) => ({
  addWrapper: {
    padding: 10,
  },
  searchText: {
    display: "inline-block",
    marginTop: 10,
    marginLeft: 5,
  },
});

export class Reseller extends React.Component {
  state = {
    isAdd: false,
    carrier: null,
    limit: 25,
    page: 0,
    accountCount: 0,
    shippingCount:0,
    supports: [],
    selected: {},
  };

  async componentDidMount() {
    await this.onReload();
  }

  onReload = async () => {
    await this.getAdminShippingCount();
    await this.getAdminShipping();
  };

  getAdminShippingCount = async () => {
    const response = await this.props.getAdminShippingCount({});
    if (response) {
    this.setState({ shippingCount: response });
    
  }
  };

  getAdminShipping = async (params) => {
    const { limit, page } = this.state;
    const skip = parseInt(page) * parseInt(limit);
    const supports = await this.props.getAdminShipping({
      limit,
      skip,
      ...params,
    });
    this.setState({ supports, loading: false });
  };

  handleOpen = () => {
    this.setState({ isAdd: true });
  };

  handleClose = () => {
    this.onReload();
    this.setState({ isAdd: false, selected: null });
  };

  handleEdit = (selected) => {
    this.setState({ isAdd: true, selected });
  };

  handleChange = ({ limit, page }) => {
    this.setState({ limit, page }, this.getAdminShipping);
  };

  timeOut = null;

  render() {
    const classes = this.props.classes;
    const { loading, isAdd, selected } = this.state;
    const supports = this.state.supports || [];

    return (
      <div>
        {isAdd && (
          <AddShippingForm
            isAdd={isAdd}
            handleClose={this.handleClose}
            selected={selected}
          />
        )}
        <Grid container className={classes.addWrapper}>
          <Grid item xs={12} sm={12} md={12}>
            <SearchBar
              handleAddClick={this.handleOpen}
              onSearch={this.getAdminShipping}
            />
          </Grid>
        </Grid>
        {loading ? (
          <div style={{ textAlign: "center" }}>
            <CircularProgress />
          </div>
        ) : (
          <>
            <ShippingTable
              items={supports}
              count={this.state.shippingCount}
              handleEdit={this.handleEdit}
              formatDate={this.props.formatDate}
              formatDateTime={this.props.formatDateTime}
              handleChange={this.handleChange}
              limit={this.state.limit}
              page={this.state.page}
            />
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      formatDate,
      formatDateTime,
      getAdminShippingCount,
      getAdminShipping,
    },
    dispatch
  );

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(Reseller)
);
